/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CompetenceIdAndTitle } from './competenceIdAndTitle';
import { LiteracyIdAndTitle } from './literacyIdAndTitle';
import { SkillIdColorAndTitle } from './skillIdColorAndTitle';

export interface ActivityRead { 
    /**
     * Zadejte název aktivity.
     */
    title: string;
    /**
     * Zadejte podrobný popis aktivity.
     */
    description?: string;
    skills: Array<SkillIdColorAndTitle>;
    competencies: Array<CompetenceIdAndTitle>;
    literacies: Array<LiteracyIdAndTitle>;
    /**
     * Zaškrtněte, pokud je tato aktivita doporučená pro 1. úroveň.
     */
    isFirstLevelRecommended?: boolean;
    /**
     * Zaškrtněte, pokud je tato aktivita doporučená pro 2. úroveň.
     */
    isSecondLevelRecommended?: boolean;
    /**
     * Zaškrtněte, pokud je tato aktivita doporučená pro 3. úroveň.
     */
    isThirdLevelRecommended?: boolean;
    readonly id: string;
    readonly recordCount: number;
    readonly affectedChildren: number;
    readonly createdByFirstName: string;
    readonly createdByLastName: string;
    readonly isFavorite: boolean;
    /**
     * Activity is readonly only if activity_template is present
     */
    readonly isReadonly: boolean;
}